import ReactGA from "react-ga4";

let hasConsent = false;

export function initAnalytics(trackingId, consent) {
  hasConsent = consent;
  if (hasConsent) {
    ReactGA.initialize(trackingId);
  }
}

export function trackPageView(path) {
  if (!hasConsent) return;
  ReactGA.send({ hitType: "pageview", page: path });
}

export function trackAddToCart(product, quantity, variant) {
  if (!hasConsent) return;
  if (variant == 1) variant = '';
  ReactGA.event("add_to_cart", {
    currency: "HUF",
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        quantity: quantity,
        item_variant: variant
      }
    ],
  });
}
